import React, { useMemo } from 'react';
import styled, { useTheme } from 'styled-components';

import { LogoBlackWordmark, LogoWordmark } from 'src/packages/icons/logo';
import { LogoProps } from './Logo.types';
import { Text } from '../text';
import { DarkTheme, LightTheme } from 'src/packages/theme';

const LogoContainer = styled.div<LogoProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.theme.rtl ? 'flex-end' : 'flex-start')};
  cursor: pointer;
  gap: 20px;

  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: column;
    align-items: ${(props) => (props.theme.rtl ? 'flex-end' : 'flex-start')};
    gap: 6px;

    > svg {
      max-width: 125px;
    }
  }
`;

const Logo: React.FC<LogoProps> = ({ theme, title }: LogoProps) => {
  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'light'
        ? { ...LightTheme, rtl: contextTheme.rtl }
        : { ...DarkTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  return (
    <LogoContainer
      onClick={() => {
        window.location.href = '/';
      }}
    >
      {theme === 'dark' ? <LogoWordmark /> : <LogoBlackWordmark />}

      {title && (
        <Text
          variant={'p2'}
          textTransform={'uppercase'}
          text={title}
          color={defaultTheme.colors.palette.white}
        />
      )}
    </LogoContainer>
  );
};

export default Logo;
